import React from "react";
import { Input, Label } from "reactstrap";

const StockItemTypeTabs = ({ itemType, onChange, t, idPrefix = "stock" }) => (
	<div className="mb-3">
		<label className="form-label mb-2">{t("Item Type")}</label>
		<div className="d-flex align-items-center flex-wrap" style={{ gap: "20px" }}>
			<div className="radio radio-primary mb-0">
				<Input
					id={`${idPrefix}-medicine`}
					type="radio"
					name={`${idPrefix}-itemType`}
					checked={itemType === "medicine"}
					onChange={() => onChange("medicine")}
				/>
				<Label for={`${idPrefix}-medicine`} className="ps-3 mb-0">
					{t("Medicine")}
				</Label>
			</div>
			<div className="radio radio-primary mb-0">
				<Input
					id={`${idPrefix}-unani`}
					type="radio"
					name={`${idPrefix}-itemType`}
					checked={itemType === "unani"}
					onChange={() => onChange("unani")}
				/>
				<Label for={`${idPrefix}-unani`} className="ps-3 mb-0">
					{t("U Medicine")}
				</Label>
			</div>
			<div className="radio radio-primary mb-0">
				<Input
					id={`${idPrefix}-otc`}
					type="radio"
					name={`${idPrefix}-itemType`}
					checked={itemType === "otc"}
					onChange={() => onChange("otc")}
				/>
				<Label for={`${idPrefix}-otc`} className="ps-3 mb-0">
					{t("OTC Product")}
				</Label>
			</div>
		</div>
	</div>
);

export default StockItemTypeTabs;
